// iter416 — Dashboard "Status" strip section.
// iter603 — Now also includes BranchPrinterHealthWidget, which
// auto-hides when no printers are configured.
// Compact tile row: ReconciliationCheck · SetupScoreRing ·
// OutstandingAdvances · DeployStatus · BranchPrinterHealth (if any).
// Pure layout — the inner widgets handle their own data + visibility.
import { DashboardSection } from './DashboardSection';
import ReconciliationCheckWidget from './ReconciliationCheckWidget';
import SetupScoreRing from './SetupScoreRing';
import OutstandingAdvancesTile from './OutstandingAdvancesTile';
import DeployStatusWidget from './DeployStatusWidget';
import DeploymentHealthBadge from './DeploymentHealthBadge';
import BranchPrinterHealthWidget from './BranchPrinterHealthWidget';

export function StatusStripSection() {
  return (
    <DashboardSection title="Status" subtitle="reconciliation, setup, advances, printers, system" testId="dash-section-status" collapsible defaultOpen={false}>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 items-stretch">
        <div className="min-w-0"><ReconciliationCheckWidget /></div>
        <div className="min-w-0"><SetupScoreRing /></div>
        <div className="min-w-0"><OutstandingAdvancesTile /></div>
        <div className="min-w-0"><DeployStatusWidget /></div>
        <div className="min-w-0"><BranchPrinterHealthWidget /></div>
      </div>
      <DeploymentHealthBadge />
    </DashboardSection>
  );
}

export default StatusStripSection;
